export const POSITION = new Float32Array([
  -1, -1,
  1, -1,
  -1, 1,
  -1, 1,
  1, -1,
  1, 1
]);

export const TEX_COORD = new Float32Array([
  0, 1,
  1, 1,
  0, 0,
  0, 0,
  1, 1,
  1, 0
]);
